import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  Popup,
  Preloader,
  Button,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const UnlinkAccountConfirmationPopup = ({
  isConfirmationPopupOpened,
  isAccountLinkDeleting,
  onClose,
  onDelete,
  children,
  deleteButtonText,
  cancelButtonText,
}) => (
  <Popup
    className={cx('popupWrapper')}
    opened={isConfirmationPopupOpened}
    onClose={() => !isAccountLinkDeleting && onClose()}
  >
    {children}
    {isAccountLinkDeleting
      ? (
        <Preloader
          className={cx('spinner')}
          size="80"
        />
      )
      : (
        <>
          <Button
            className={['default', cx('popupButton')]}
            onClick={onDelete}
          >
            {deleteButtonText}
          </Button>
          <Button
            className={cx('popupButton')}
            onClick={onClose}
          >
            {cancelButtonText}
          </Button>
        </>
      )}
  </Popup>
);

UnlinkAccountConfirmationPopup.propTypes = {
  isConfirmationPopupOpened: PropTypes.bool,
  isAccountLinkDeleting: PropTypes.bool,
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
  children: PropTypes.any,
  deleteButtonText: PropTypes.any,
  cancelButtonText: PropTypes.any,
};

export default UnlinkAccountConfirmationPopup;
